import { useWorkflowContext } from 'app-context/worflow/WorkflowContext';
import RightSlider from 'component/hoc/rightSlider/RightSlider';
import DocumentForm from 'component/organism/workflow/forms/document-form/DocumentForm';
import { FormikProvider, useFormik } from 'formik';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import * as Yup from 'yup';
const DocumentModal = ({
  isOpen,
  onClose,
  title,
  id,
  allowedExtensions,
  isError,
}) => {
  const {
    workflowData,
    setWorkflowData,
    selectedNode,
    initialWorkflowData,
    setIsChanged,
  } = useWorkflowContext();

  const getValidationSchema = () => {
    return Yup.object().shape({
      isURL: Yup.boolean(),
      uploadedFile: Yup.string(),
      url: Yup.string().when('isURL', {
        is: true,
        then: (schema) => schema.required('URL is required'),
        otherwise: (schema) => schema.notRequired(),
      }),
      file: Yup.object().shape({
        fileName: Yup.string().when('isURL', {
          is: false,
          then: (schema) => schema.required('File name is required'),
          otherwise: (schema) => schema.notRequired(),
        }),
        contentType: Yup.string().when('isURL', {
          is: false,
          then: (schema) => schema.required('Content type is required'),
          otherwise: (schema) => schema.notRequired(),
        }),
        fileContent: Yup.mixed().when('isURL', {
          is: false,
          then: (schema) => schema.required('File content is required'),
          otherwise: (schema) => schema.notRequired(),
        }),
      }),
    });
  };
  const formik = useFormik({
    initialValues: {
      uploadedFile: selectedNode?.media?.uploadedFile || '',
      url: selectedNode?.media?.url || '',
      isURL: selectedNode?.media?.isURL || false,
      file: selectedNode?.media?.file || {
        contentType: '',
        fileName: selectedNode?.media?.fileName || '',
        fileContent: '',
      },
    },
    enableReinitialize: true,
    validationSchema: getValidationSchema(),
    onSubmit: (values, { resetForm }) => {
      const initialNode = initialWorkflowData?.find((node) => node?.id === id);

      if (initialNode) {
        const { fileName } = initialNode?.media || {};
        const currentValues = values.fileName;
        const changed = values?.uploadedFile;
        setIsChanged((prev) => {
          const alreadyExists = prev?.includes(id);
          if (changed && !alreadyExists) {
            return [...prev, id];
          }
          if (!changed && alreadyExists) {
            return prev?.filter((nodeId) => nodeId !== id);
          }

          return prev;
        });
      }
    },
  });

  const handleSubmit = async () => {
    await formik.handleSubmit();
    try {
      setTimeout(() => {
        // const isUrl = formik.values?.url !== '';
        const valuesToSend = {
          ...formik.values,
          isURL: !formik.values.file.fileContent ? true : false,
        };
        const updatedNodes = workflowData?.nodes?.map((node) =>
          node.id === id
            ? { ...node, media: valuesToSend, is_Error: isError }
            : node
        );
        setWorkflowData((prev) => ({
          ...prev,
          nodes: updatedNodes,
        }));
        onClose();
        formik.resetForm();
      }, [100]);
    } catch {
      toast.error('Something went wrong');
    }
  };

  useEffect(() => {
    const updatedNodes = workflowData?.nodes?.map((node) =>
      node.id === id ? { ...node, is_Error: isError } : node
    );

    setWorkflowData((prev) => ({
      ...prev,
      nodes: updatedNodes,
    }));
  }, [isError]);

  useEffect(() => {
    if (isError) {
      formik.handleSubmit();
    }
  }, [isOpen]);
  return (
    <RightSlider
      title={title}
      action={{
        isOpen: isOpen,
        setIsOpen: handleSubmit,
      }}
    >
      <FormikProvider value={formik}>
        <DocumentForm allowedExtensions={allowedExtensions} onClose={onClose} />
      </FormikProvider>
    </RightSlider>
  );
};

export default DocumentModal;
